<div fxLayout="column" fxLayoutAlign="start start" class="footer_header">
	<span
		i18n="@@footer_label_support"
		class="footer-titles mat-headline-6 support p-l-xs"
		*ngIf="showSupportHeader"
	>
		Support
	</span>
	<a
		i18n="@@footer_label_helpdesk"
		(click)="languageDetectorForHelpDesk('https://helpdesk')"
		class="helpdesk break-word"
		style="cursor: pointer"
	>
		Helpdesk
	</a>
	<a
		i18n="@@footer_label_aboutWhydonateFoundation"
		[href]="aboutHref"
		class="about break-word"
		style="cursor: pointer"
	>
		About Whydonate
	</a>
	<a
		i18n="@@footer_label_fundraisingTipsAndTricks"
		[href]="tipsHref"
		class="fundraising break-word"
		style="cursor: pointer"
	>
		Fundraising Tips & Tricks
	</a>
	<a
		i18n="@@footer_label_blog"
		[href]="blogHref"
		class="blog"
		style="cursor: pointer"
	>
		Blog
	</a>
	<a
		i18n="@@footer_label_fees"
		[href]="feesHref"
		class="fees"
		style="cursor: pointer"
	>
		Fees
	</a>
	<a
		i18n="@@footer_label_contact"
		[href]="contactHref"
		class="contact break-word"
		style="cursor: pointer"
	>
		Contact
	</a>
</div>
